import React from 'react';
import { bool, shape, string } from 'prop-types';

const Visibility = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1 12C2.73 7.61 7 4.5 12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12ZM20.8197 12C19.1697 8.63 15.7897 6.5 11.9997 6.5C8.20969 6.5 4.82969 8.63 3.17969 12C4.82969 15.37 8.20969 17.5 11.9997 17.5C15.7897 17.5 19.1697 15.37 20.8197 12ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM7.5 12C7.5 9.52 9.52 7.5 12 7.5C14.48 7.5 16.5 9.52 16.5 12C16.5 14.48 14.48 16.5 12 16.5C9.52 16.5 7.5 14.48 7.5 12Z" fill="currentColor" />
  </svg>
);

Visibility.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default Visibility;
